import React, {Fragment} from 'react';
import {Box, Button, Typography} from '@material-ui/core';
import {Link} from 'react-router-dom';

function Home() {
    return (
        <Fragment>
            <Box>
                <Typography variant='h3' color='primary' align='center'>
                    {'AML - ONBOARDING'}
                </Typography>
                <Typography variant='h4' color='textPrimary' align='center'>
                    {'Theme Demo'}
                </Typography>
            </Box>
            <Box alignSelf='center'>
                <Button
                    size='large'
                    color='primary'
                    component={Link}
                    to={{pathname: '/blank/palette'}}>
                    {'Go!'}
                </Button>
            </Box>
        </Fragment>
    );
}

export default Home;
